import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="chart"
export default class extends Controller {
  static values = { options: Object, data: Object, yAxisTitle: { type: String, default: "kWh" } }
  static targets = ["canvas"]

  connect() {
    new Chart(this.canvasTarget, {
      type: 'bar',
      data: this.dataValue,
      options: {
        scales: {
          x: { stacked: true},
          y1: {
            beginAtZero: true,
            stacked: true,
            position: 'left',
            title: {
              display: true,
              text: this.yAxisTitleValue
            }
          },
          y2: { type: 'linear', position: 'right', title: { display: true, text: "Taux d'autoconso" } }
        }
      }
    });

  }
}
